import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import AttendeeListing from 'views/admin/attendees/AttendeeListing'
import AttendeeForm from 'views/admin/attendees/AttendeeForm'

const Attendees = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <AttendeeListing />
      </Route>
      <Route path={`${path}/edit/:attendeeId`}>
        <AttendeeForm />
      </Route>
    </Switch>
  )
}

export default Attendees
